import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyAmK1_MSeDdRp-EQt2lrk7bjshDQotTw38",
  authDomain: "stridhaga.firebaseapp.com",
  projectId: "stridhaga",
  storageBucket: "stridhaga.firebasestorage.app",
  messagingSenderId: "650797657907",
  appId: "1:650797657907:web:6d7208affb6922a7769846",
  measurementId: "G-1EB4V45DR6",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
